module.exports = __webpack_public_path__ + "static/img/sec06.a3ce436f.svg";